import { createStore } from 'vuex'

export default createStore({
  state: {
    userDetails: null
  },
  getters: {
    getUserDetails: (state) => state.userDetails,
  },
  mutations: {
    setUserDetails(state, value) {
      state.userDetails = value
    }
  },
  actions: {
  },
  modules: {
  }
})
